import { cloneDeep, omit } from 'lodash';

export const excludeCoverSpreadAndId = (spreads) =>
  cloneDeep(spreads)
    .filter(({ isCoverSlide }) => !isCoverSlide)
    .map((spread, index) => ({ ...omit(spread, ['_id']), index }));
